.summary {
    border: 1px solid var(--mantine-color-dark-3);
    border-radius: var(--mantine-radius-sm);
    background: var(--mantine-color-dark-5);
}

.conversationalSummary {
    border: 1px solid var(--mantine-color-dark-3);
    border-radius: var(--mantine-radius-sm);
    background: linear-gradient(var(--mantine-color-primary-1), var(--mantine-color-primary-0));
    color: var(--mantine-color-dark-7);
}
